/**
 * Joins the parts of a section summary alphabetically, the way the user's language lists things,
 * e.g. "Boot animation, Wallpaper". Sorting keeps the header identical for two profiles that hold the same
 * settings, whatever order they were switched on in.
 */
export const formatSummaryList = (parts: string[], language: string) =>
    new Intl.ListFormat(language, { style: "short", type: "unit" }).format(
        [...parts].sort((first, second) => first.localeCompare(second, language)),
    );
